import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { actionCreators, store } from "@App/state";
import { bindActionCreators } from "@reduxjs/toolkit";

/**
 * A custom hook that checks if all needed data was loaded from the api on component mount
 * and returns a method to parse the data to the url query parameters.
 */
export const useVINParameters = () => {
  const [searchParams] = useSearchParams();

  const dispatch = useDispatch();
  const { setVIN } = bindActionCreators(actionCreators, dispatch);

  const vinQuery = searchParams.get("vin");

  useEffect(() => {
    if (vinQuery) {
      setVIN(vinQuery);
    }
  }, [vinQuery]);

  const vinQueryParams = (): Record<string, string> => {
    return {
      ...(store.getState().orders.vin && {
        vin: store.getState().orders.vin,
      }),
    };
  };

  return { vinQueryParams };
};
